import { render } from "./InviteView.vue?vue&type=template&id=55465a59&scoped=true"
import script from "./InviteView.vue?vue&type=script&lang=js"
export * from "./InviteView.vue?vue&type=script&lang=js"

import "./InviteView.vue?vue&type=style&index=0&id=55465a59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55465a59"]])

export default __exports__